import styled from "styled-components";
import { space, layout, flexbox, color } from "styled-system";

import { BoxProps } from "./box.type";

const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  ${space}
  ${layout}
  ${flexbox}
  ${color}
  ${(props) => props.css}
`;

export default Box;
